import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RefreshFbPageTokenData } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const refreshFbPageToken = (data: RefreshFbPageTokenData): Promise<void> => {
  return axios.post(`/meta/pages/refresh-token`, data);
};

type RefreshFbPageTokenOptions = {
  config?: MutationConfig<typeof refreshFbPageToken>;
};

export function useRefreshFbPageToken({ config = {} }: RefreshFbPageTokenOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: () => {
      toasts.loadingToast.success('refresh-fb-token', 'Page FB token was refreshed');
      queryClient.invalidateQueries(['pages']);
    },
    onError: (error: AxiosError<{ error: string }>) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('refresh-fb-token', serverMessage);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('refresh-fb-token', 'Refreshing page FB token...');
      config.onMutate?.(...args);
    },
    mutationFn: refreshFbPageToken,
  });
}
